import.meta.glob("./templates/**/*.{js,hbs,jst.ejs}", { eager: true });
import.meta.glob("./views/**/*.{js,hbs,jst.ejs}", { eager: true });
import "virtual:client-templates/app/assets/javascripts/appointment_booking/related_providers_widget/templates";

window.AppointmentBooking ??= {};

// Merged per key: Vite hoists the eager glob imports above this body, so
// `views/widget.js` has already attached `Views.Widget` by the time it runs.
window.AppointmentBooking.RelatedProvidersWidget ??= {};

const widget = window.AppointmentBooking.RelatedProvidersWidget;
widget.Views ??= {};
widget.Models ??= {};
widget.Collections ??= {};
